// ==============================|| OVERRIDES - DATA GRID ||============================== //

import SortIcon from "../../assets/images/icons/dataGrid/sortIcon";
const Sort = (props) => {
	const {sortingOrder, ...other} = props
	return <SortIcon {...other} />
}
export default function DataGrid(theme) {
	return {
		MuiDataGrid: {
			defaultProps: {
				slots: {
					sortingOrder: ['asc', 'desc', null],
					columnUnsortedIcon: Sort,
				}
			},
			styleOverrides: {
				root: {
					border: '1px solid #E8EBEC',
					borderTopRightRadius: 0,
					borderTopLeftRadius: 0,
					borderBottomRightRadius: '8px',
					borderBottomLeftRadius: '8px',
					fontSize: '14px',
					lineHeight: '24px',
					paddingLeft: '32px',
					paddingRight: '32px',
					color: theme.palette.text.main,
					'--DataGrid-rowBorderColor': 'rgba(0, 0, 0, 0)', // Custom χρώμα για αφαίρεση γραμμών μεταξύ εγγραφών - γραμμών
					"& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer": {
						visibility: "visible",
						width: "auto"
					},
					// '& .MuiDataGrid-columnSeparator': {
					// 	display: 'none', // Κρύβει τους διαχωριστές των στηλών
					// },
					"& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon": {
						opacity: 1,
						'&:hover': {
							opacity: 5
						}
					},
					'& .MuiDataGrid-columnHeaderTitle': {
						fontSize: '14px',
						fontWeight: 400,
						lineHeight: '22px',
					},
					'& .MuiSvgIcon-root': {
						// color: theme.palette.primary[800]
						// color: 'white'
						// Εδώ πειράζετε το χρώμα του icon
					},
					'& .MuiDataGrid-booleanCell[data-value="false"]': {
						color: theme.palette.primary[800]
					},
					'& .MuiDataGrid-booleanCell[data-value="true"]': {
						color: theme.palette.primary[800]
					},
					'& .MuiCheckbox-root': {
						borderRadius: '8px'
					},
					'& .MuiDataGrid-menu': {
						borderRadius: 10
					},
					row: {
						borderBottom: 'none',
						// background: '#c50909'
					},
					cell: {
						// borderBottom: `2px solid #C00909`,
					},
					'& .MuiTablePagination-root': {
						minHeight: '55px'
					},
					//rows per page color
					/*'& .MuiTablePagination-selectLabel': {
						color: 'red',
						alignSelf: 'stretch',
						//marginLeft: 'auto',
						marginLeft: 0,
					},*/
					//rows per page top border
					/*'& .MuiDataGrid-footerContainer': {
						height: '40px',
						borderTop: '4px solid #E1E2E9'
					},*/
					//select how much rows per page
					/*'& .MuiInputBase-root': {
						color: 'red',
						background: 'rgba(94, 99, 102, 0.08)',
						borderRadius: '8px',
						
						display: 'inline-flex',
						height: '23px',
						width: '65px',
						padding: '0px 11px',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '10px',
						flexShrink: 0,
					},*/
					//select how much rows per page
					/*'& .MuiSelect-select': {
						display: 'flex',
						alignItems: 'center',
						color: 'red',
						background: 'rgba(94, 99, 102, 0.08)',
						borderRadius: '8px',
					},*/
					//1 of pages
					/*'& .MuiTablePagination-displayedRows': {
						color: '#d01414',
						fontSize: '14px',
						fontWeight: 400,
						lineHeight: '22px'
					},*/
					
				},
				
				/*columnHeader: {
					background: '#b41212'
				},*/
				/*columnHeaderTitle: {
					fontSize: '14px',
					color: 'red',
					//fontFamily: 'Mona',
					fontStyle: 'normal',
					fontWeight: 400,
					lineHeight: '22px'
				},*/
			},
		},
	}
}

